module.exports = {
  development: 'development',
  local: 'local',
  production: 'production',
  staging: 'staging',
};
